import { render } from "./SortTableFirstRowComponent.vue?vue&type=template&id=7a415b24&scoped=true"
import script from "./SortTableFirstRowComponent.vue?vue&type=script&lang=js"
export * from "./SortTableFirstRowComponent.vue?vue&type=script&lang=js"

import "./SortTableFirstRowComponent.vue?vue&type=style&index=0&id=7a415b24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a415b24"]])

export default __exports__